import { Reducer } from 'redux';
import { PlataformaState, PlataformaTypes } from './types';

const INITIAL_STATE: PlataformaState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<PlataformaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PlataformaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case PlataformaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };

    case PlataformaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };

    case PlataformaTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
